import { render, staticRenderFns } from "./available_spklu.vue?vue&type=template&id=131f1236&scoped=true&"
import script from "./available_spklu.vue?vue&type=script&lang=js&"
export * from "./available_spklu.vue?vue&type=script&lang=js&"
import style0 from "./available_spklu.vue?vue&type=style&index=0&id=131f1236&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131f1236",
  null
  
)

export default component.exports